const env = process.env.NODE_ENV || 'development';
const configs = {
  base: {
    env,
    wfApiBasePath: process.env.REACT_APP_WF_BASE_PATH,
    wfApiKey: process.env.REACT_APP_WF_APIKEY,
    wfStaffAccessToken: process.env.REACT_APP_WF_STAFF_TOKEN,
    wfSecureApiBasePath: process.env.REACT_APP_WF_SECURE_BASE_PATH,
    wfSecureApiKey: process.env.REACT_APP_WF_SECURE_APIKEY,
    internalHost: process.env.REACT_APP_HOST,
    cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
    uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET
  }
};

const config = { ...configs.base, ...configs[env] };

export default config;